import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFiles, resetState, StateStatus } from '@guryou/redux';
import { ActionStatus, buildActionType } from '../core';
import { ADD_FILE_TO_SECTION, CREATE_FILE, DELETE_ALL_FILES_IN_SECTION, DELETE_FILE, FILES, FILES_REORDER, SECTIONS, UPDATE_FILE, UPLOAD_FILE } from '../new';
const useFiles = _ref => {
  let {
    sectionId,
    silent,
    toResetModal = true
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => state.files.all);
  const {
    update,
    upload,
    create,
    remove,
    reorder,
    addToSection,
    deleteAllFilesInSection
  } = useSelector(state => state.files);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && (request === null || request === void 0 ? void 0 : request.sectionId) !== sectionId) {
      dispatch(getFiles(sectionId, silent));
    }
    if (update.version || remove.version || reorder.version || addToSection.version || create.version || deleteAllFilesInSection.version) {
      update.version && dispatch(resetState(UPDATE_FILE));
      upload.version && dispatch(resetState(UPLOAD_FILE));
      reorder.version && dispatch(resetState(FILES_REORDER));
      if (deleteAllFilesInSection.version) {
        var _deleteAllFilesInSect;
        dispatch({
          type: buildActionType(SECTIONS, ActionStatus.UPDATE),
          index: (_deleteAllFilesInSect = deleteAllFilesInSection.data) === null || _deleteAllFilesInSect === void 0 ? void 0 : _deleteAllFilesInSect.sectionIndex
        });
        dispatch(resetState(DELETE_ALL_FILES_IN_SECTION));
      }
      if (create.version) {
        var _create$data;
        dispatch({
          type: buildActionType(SECTIONS, ActionStatus.INCREASE),
          index: (_create$data = create.data) === null || _create$data === void 0 ? void 0 : _create$data.sectionIndex
        });
        dispatch(resetState(CREATE_FILE));
      }
      if (remove.version) {
        var _remove$data;
        dispatch({
          type: buildActionType(SECTIONS, ActionStatus.DECREASE),
          index: (_remove$data = remove.data) === null || _remove$data === void 0 ? void 0 : _remove$data.sectionIndex
        });
        dispatch(resetState(DELETE_FILE));
      }
      if (addToSection.version) {
        var _addToSection$data;
        dispatch({
          type: buildActionType(SECTIONS, ActionStatus.INCREASE),
          index: (_addToSection$data = addToSection.data) === null || _addToSection$data === void 0 ? void 0 : _addToSection$data.sectionIndex
        });
        dispatch(resetState(ADD_FILE_TO_SECTION));
      }
      dispatch(resetState(FILES));
      if (toResetModal) {}
    }
    //eslint-disable-next-line
  }, [dispatch, sectionId, request, silent, status, update.version, upload.version, remove.version, create.version, remove, create, reorder.version, addToSection.version, deleteAllFilesInSection.version]);
  if (!sectionId) {
    return {
      data: null,
      status: StateStatus.NOT_INITIALIZED
    };
  }
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useFiles;